<template>
  <main>
    <div class="container container-fluid">
      <div class="container">
        <al-notify v-if="bannerText" success name="promotional-banner">
          {{ $t(bannerText) }}
        </al-notify>
        <al-notify v-else-if="errorToken" error name="error-msg">
          {{ $t(errorToken) }}
        </al-notify>

        <div class="row">
          <div class="col">
            <h1 class="heading-xl align-center-space-between">
              {{ $t('cards.heading') }}
            </h1>
            <p data-test="subheading">{{ $t('cards.subheading') }}</p>
          </div>
        </div>

        <div v-if="sortedCards.length" class="row">
          <div data-test="list-card-item" class="col-full">
            <al-list card>
              <al-list-item
                v-for="card in sortedCards"
                :key="card.id"
                wrap
                :name="`card-info-${card.id}`"
                :error="cardErrorMessage(card)"
                @click="selectCard(card)">
                <al-card-preview
                  :img="card.artUrl"
                  :brand="getCardBrand(card)"
                  :number="`•••• ${card.primaryAccountNumberSuffix}`"
                  :name="`card-list-preview`" />
              </al-list-item>
            </al-list>
          </div>
        </div>

        <div v-else data-test="cards-empty-state" class="row row-vertical-align-center">
          <div class="col-full align-center">
            <i class="h2 icon-card icon-size-lg" />
            <h3>
              {{ $t('cards.noCards') }}
            </h3>
            <p class="color-secondary">
              {{ $t('cards.addNewCard') }}
            </p>
          </div>
        </div>

        <div class="row row-vertical-align-bottom">
          <div class="col-full align-center">
            <button
              v-analytics:click="$EVENTS.ADD_CARD_BUTTON"
              data-test="add-card-btn"
              class="fill uppercase"
              :aria-label="$t('cards.addCard')"
              @click="addCard">
              {{ $t('cards.addCard') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlCardPreview, AlList, AlListItem, AlNotify } from '@mc-alberta/alcapone'
import { mapActions, mapGetters } from 'vuex'
import { ACTION, CARD_STATUS, ROUTES } from '@/constants'

export default {
  name: ROUTES.LIST_CARDS,
  components: { AlCardPreview, AlList, AlListItem, AlNotify },
  data() {
    return {
      addedNewCard: this.$route.params.addedNewCard,
      cardToBeDeleted: null,
      errorToken: '',
      isNewUser: this.$route.params.isNewUser,
      isCardDeleted: this.$route.params.isCardDeleted
    }
  },
  computed: {
    ...mapGetters(['sortedCards']),
    bannerText() {
      let token

      if (this.isNewUser) {
        token = 'cards.bannerNewUser'
      } else if (this.isCardDeleted) {
        token = 'cards.bannerDeletedCard'
      } else if (this.addedNewCard) {
        token = 'cards.bannerAddedCard'
      }

      return token
    }
  },
  mounted() {
    this.setAction(ACTION.MANAGE)
    this.errorToken = this.$route.params.errorToken || ''
  },
  methods: {
    ...mapActions(['setAction']),
    addCard() {
      this.$router.push({ name: ROUTES.ADD_CARD })
    },
    getCardBrand(card) {
      return card.shortProductDescription || card.issuerName || card.paymentNetworkName
    },
    selectCard(card) {
      const { id, paymentNetworkName, createTime, lastUsedTime } = card

      this.$analytics.track({
        event: this.$EVENTS.CARD_SELECT_CLICK,
        meta: {
          cardId: id,
          paymentNetworkName,
          createTime,
          lastUsedTime
        }
      })
      this.$router.push({
        name: ROUTES.CARD_DETAILS,
        params: { cardId: card.id }
      })
    },
    cardErrorMessage(card) {
      let errorMessage = ''

      if (card.status === CARD_STATUS.EXPIRED) {
        errorMessage = this.$t('cards.expired')
      } else if (card.status === CARD_STATUS.SUSPENDED) {
        errorMessage = this.$t('cards.unavailable')
      }

      return errorMessage
    }
  }
}
</script>
